import { Button, Typography } from "@mui/material";
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../shared-components/navbar/Navbar";
import {
  ButtonBox,
  HeaderChild,
  HeaderContainer,
  HeaderLeft,
  HeaderRight,
} from "./header.style";
import headerShape from "../../../assets/images/header-shape.png";
import headerImage from "../../../assets/images/header-image.png";
import { Link } from "react-router-dom";
import ConfettiExplosion from "react-confetti-explosion";

const Header = () => {
  const [isExploding, setIsExploding] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  const handleButtonClick = (e) => {
    e.preventDefault(); // Prevent default Link navigation
    if (!hasTriggered) {
      setIsExploding(true);
      setHasTriggered(true); // Prevent re-triggering
      setTimeout(() => {
        setIsExploding(false);
        navigate("/special-offers"); // Navigate after confetti
      }, 2000);
    } else {
      navigate("/special-offers"); // Navigate without confetti
    }
  };
  // const handleButtonClick = (e) => {
  //   return navigate("/about");
  // };

  return (
    <HeaderContainer>
      <Navbar />
      <HeaderChild>
        <HeaderLeft>
          <Typography variant="h4">
            Get the Next <br /> Level Developments.{" "}
          </Typography>
          <Typography variant="body1">
            Every line of code we deliver is carefully crafted by our in-house
            team of professional developers. While constantly looking for new
            horizons, challenges, and opportunities in AI, web development and
            cloud maintenance, we have focused our attention on specific core
            areas.
          </Typography>
          <ButtonBox>
            <div style={{ position: "relative", display: "inline-block" }}>
              <Link to="/special-offers" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  ref={buttonRef}
                  onClick={handleButtonClick}
                >
                  Special Offers
                </Button>
              </Link>
              {isExploding && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 9999,
                  }}
                >
                  <ConfettiExplosion
                    force={0.8}
                    duration={3000}
                    particleCount={200}
                    width={1200}
                    height={1200}
                    colors={["#ff0", "#f00", "#0f0", "#00f", "#ff69b4"]}
                  />
                </div>
              )}
            </div>
            <Link to="/call">
              <Button variant="contained" className="call">
                Schedule a call
              </Button>
            </Link>
          </ButtonBox>
        </HeaderLeft>
        <HeaderRight>
          <img
            src={headerImage}
            alt="header"
            loading="lazy"
            className="header-image"
          />
          <img
            src={headerShape}
            alt="header"
            loading="lazy"
            className="header-shape"
          />
        </HeaderRight>
      </HeaderChild>
    </HeaderContainer>
  );
};

export default Header;
